var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tagName,{tag:"component",class:_vm.classes,attrs:{"disabled":_vm.itemDisabled},on:{"click":_vm.handleClickLink}},[(_vm.loading)?_c('i',{staticClass:"yjui-load-loop icon-shuaxin_1"}):_vm._e(),_vm._v(" "),(_vm.icon)?_c('i',{class:_vm.icon}):_vm._e(),_vm._v(" "),(_vm.showSlot)?_c('span',{ref:"slot"},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c4d532c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/button/button.vue
// module id = null
// module chunks = 